import { InjectionToken } from '@angular/core';

export const LoginRedirectToken = new InjectionToken<string>('loginRedirect');
export const AuthProviderToken = new InjectionToken<string>('authProvider');
export const SignUpUrlToken = new InjectionToken<string>('signUpUrl');
